module.exports = __webpack_public_path__ + "static/media/5.513d2f4b.jpg";